<ion-list *ngIf="!order">
    <ion-button type="button" (click)="clearList($event)" fill="clear" color="secondary">
        <ion-icon name="refresh" slot="start"></ion-icon>
        <ion-label>Clear all</ion-label>
    </ion-button>
    <ion-item *ngFor="let item of list; let i = index; trackBy: trackByIndex">
        <ion-checkbox slot="start" (click)="pick($event, item)" [checked]="item?.checked"></ion-checkbox>
        <ion-label *ngIf="!item?.display"> {{ item?.value }} </ion-label>
        <ion-label *ngIf="item?.display">
            {{ item?.display }}
        </ion-label>
    </ion-item>
</ion-list>
<ion-list *ngIf="order">
    <ion-radio-group>
        <ion-item *ngFor="let item of list; let i = index; trackBy: trackByIndex">
            <ion-radio slot="start" checked="{{ item?.checked }}" value="{{ item?.value }}" (ionSelect)="orderUp($event, item)"> </ion-radio>
            <ion-label>
                {{ item?.label }}
            </ion-label>
        </ion-item>
    </ion-radio-group>
</ion-list>

<!-- 
<ion-list *ngIf="cities && !states && !order">
    <ion-button type="button" (click)="clearList($event)" fill="clear" color="secondary">
      <ion-icon name="refresh" slot="start"></ion-icon>
      <ion-label>Clear all1</ion-label>
    </ion-button>
    <ion-item *ngFor="let item of list; let i = index; trackBy: trackByIndex">
      <ion-checkbox slot="start" (clicked)="pick($event)" [(ngModel)]="item.checked"></ion-checkbox>
      <ion-label>
        {{item?.city}}, {{item?.state}}
      </ion-label>
    </ion-item>
  </ion-list>
  <ion-list *ngIf="states && !cities && !order">
    <ion-button type="button" (click)="clearList($event)" fill="clear" color="secondary">
      <ion-icon name="refresh" slot="start"></ion-icon>
      <ion-label>Clear all2</ion-label>
    </ion-button>
    <ion-item *ngFor="let item of list; let i = index; trackBy: trackByIndex">
      <ion-checkbox slot="start" (clicked)="pick($event)" [(ngModel)]="item.checked"></ion-checkbox>
      <ion-label>
        {{item?.state}}
      </ion-label>
    </ion-item>
  </ion-list> -->
